module.exports = __webpack_public_path__ + "static/img/design-banners_mob.8aed8350.png";